import { BrowserNotificationPermissionBanner } from "#webapp/src/components/browser-notification-permission-banner";
import { ModernWrapperPage } from "#webapp/src/components/modern-wrapper";
import { requireApp } from "#webapp/src/util/auth.util";
import { paths } from "@clockwise/client-commons/src/constants/site";
import { Null } from "@clockwise/web-commons/src/components/null";
import {
  appPaths,
  pagePaths,
  webappPathRoot,
} from "@clockwise/web-commons/src/constants/route.constants";
import { Redirect, Route, makeRouteConfig } from "found";
import * as React from "react";
import { AppNav } from "../components/app-nav/AppNav";
import WebLayout from "../components/web-layout/WebLayout";
import GatewayTestPage from "../pages/GatewayTestPage";
import PlannerPage from "../pages/PlannerPage";
import { AppRouter } from "./AppRouter";
import { getComponentOrRedirect, requireExtensionStoreRedirect } from "./routes.util";

//////////////////
// ROUTE CONFIG
//////////////////
const subRootRoutes = (
  <>
    <Route
      path={webappPathRoot}
      getComponent={(props) => getComponentOrRedirect(WebLayout, requireApp, props)}
      data={{ withToolbar: true }}
    >
      <Route path={pagePaths.testPage}>
        {{
          secondary: <Route path="(.*)?" Component={AppNav} />,
          children: <Route path="/" Component={GatewayTestPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
    </Route>
    <Route
      path={webappPathRoot}
      getComponent={(props) => getComponentOrRedirect(WebLayout, requireApp, props)}
      data={{ withToolbar: false }}
    >
      <Route path={pagePaths.planner}>
        {{
          secondary: <Route path="(.*)?" Component={AppNav} />,
          children: <Route path="/" Component={PlannerPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path="/team-analytics">
        {{
          secondary: <Route path="(.*)?" Component={AppNav} />,
          children: <Route path="/" Component={PlannerPage} />,
        }}
      </Route>
      <Route path="/autopilot-list">
        {{
          secondary: <Route path="(.*)?" Component={AppNav} />,
          children: <Route path="/" Component={PlannerPage} />,
        }}
      </Route>
      <Route path="/calendar-profile/:calendarId/:viewWeek?">
        {{
          secondary: <Route path="(.*)?" Component={AppNav} />,
          children: <Route path="/" Component={PlannerPage} />,
        }}
      </Route>
      <Route path="/event/:encodedExternalEventId/:encodedCalendarId/:fullView?">
        {{
          secondary: <Route path="(.*)?" Component={AppNav} />,
          children: <Route path="/" Component={PlannerPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Route path="/event/:encodedExternalEventId/:fullView?">
        {{
          secondary: <Route path="(.*)?" Component={AppNav} />,
          children: <Route path="/" Component={PlannerPage} />,
          banner: <Route path="/" Component={BrowserNotificationPermissionBanner} />,
        }}
      </Route>
      <Redirect from="/members" to={appPaths.members} />
    </Route>
    <Redirect from="/canary/(.*)?" to={appPaths.landing} />
    <Redirect from="/app/admin/members/(.*)?" to={appPaths.members} />
    <Redirect from="/app/admin/billing" to={appPaths.plansAndBilling} />
    <Redirect from="/app/admin/settings" to={appPaths.orgSettings} />
    <Redirect from={paths.calendar} to={appPaths.planner} />
    <Redirect from="/app/chat" to={appPaths.ai} />
    <Redirect from={paths.oneOnOnes} to={`${appPaths.flexibleMeetings}`} />
    <Redirect from="/app/settings/(.*)?" to={appPaths.preferences} />
    <Redirect from={appPaths.aiScheduler} to={appPaths.ai} />
  </>
);

export const routeConfig = makeRouteConfig(
  <>
    <Route path="/" Component={ModernWrapperPage}>
      {subRootRoutes}
    </Route>
    <Route path="/test-:mainBranch" Component={ModernWrapperPage}>
      {subRootRoutes}
    </Route>

    {/* A/B signup expeirment route that will be used by marketing to test directing using to store or webapp on marketing site */}
    <Route
      path={paths.signupExtension}
      getComponent={(props) => requireExtensionStoreRedirect(props, Null, paths.signup, true)}
    />
    <Route
      path={`${paths.invite}/:inviteToken?`}
      getComponent={(props) => requireExtensionStoreRedirect(props, Null, paths.signup, false)}
    />

    {/***********************
       React Router Routes
      ***********************/}
    <Route path="/" Component={ModernWrapperPage}>
      <Route path="(.*)?" Component={AppRouter} />
    </Route>
  </>,
);
